import Model from '@/models/Model.js';

export default class Rubric extends Model {
    static entity = 'rubrics';

    static modelName = 'Rubric';

    static fields() {
        return {
            id: this.attr(null),
            rubric_template_id: this.attr(null),
            course_id: this.attr(null),
            activity_id: this.attr(null),
            title: this.attr(null),

            ...super.fields(),

            // rubric_template: this.belongsTo('rubric_templates', 'rubric_template_id'),
            course: this.belongsTo('courses', 'course_id'),
            activity: this.belongsTo('activities', 'activity_id'),
            criterias: this.hasMany('rubric_criterias', 'rubric_id'),
        };
    }
}
